import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import { useForm, Controller } from "react-hook-form";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import Tooltip from '@material-ui/core/Tooltip';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import * as RemindersApi from '../../../../Common/Apis/RemindersApi';
import { IReminderType } from '../../store/ReminderTypeStore';
import { ICatetory, ISubCategory, timeIntervalTypeState } from '../../store/ReminderStore';
import { useSpinner } from "../../../../../core/contexts/SpinnerContext";
import { useNotification } from "../../../../../core/contexts/NotificationContext";
import { reminderTypeTabListState, reminderTypeTabIndexState, reminderTypeListRefreshState } from "../../store/ReminderTypeStore";

interface IProps {
  item: IReminderType | undefined;
}

const ReminderTypeDetail = ({ item }: IProps) => {

  const [category, setCategory] = useState<ICatetory[] | undefined>();
  const [subcategory, setSubcategory] = useState<ISubCategory[] | undefined>();

  const [reminderTypeTabList, setReminderTypeTabList] = useRecoilState(reminderTypeTabListState);
  const [listRefresh, setListRefresh] = useRecoilState(reminderTypeListRefreshState);
  const timeIntervalType = useRecoilValue(timeIntervalTypeState);
  const setTabIndex = useSetRecoilState(reminderTypeTabIndexState);

  const { setSpinner } = useSpinner();
  const { showSuccess } = useNotification();

  const { control, handleSubmit, setValue, watch, reset, formState: { errors } } = useForm({
    defaultValues: {
      typeName: item?.Name || "",
      typeCode: item?.Code || "",
      typeDesc: item?.Description || "",
      category: "",
      subcategory: "",
      isRecurring: item?.IsRecurring || false,
      timeTrigger: item?.TimeTriggerRequired || false,
      timeTriggerDueSoonThresholdIntervalTypeName: item?.TimeTriggerDueSoonThresholdIntervalTypeName || "",
      timeTriggerDueSoonThresholdIntervalValue: item?.TimeTriggerDueSoonThresholdIntervalValue || "",
      timeTriggerRepeatIntervalTypeName: item?.TimeTriggerRepeatIntervalTypeName || "",
      timeTriggerRepeatIntervalValue: item?.TimeTriggerRepeatIntervalValue || "",
      odometerTrigger: item?.OdometerTriggerRequired || false,
      odometerTriggerRepeatIntervalKm: item?.OdometerTriggerRepeatIntervalKm || "",
      odometerTriggerDueSoonThresholdIntervalKm: item?.OdometerTriggerDueSoonThresholdIntervalKm || "",
      setNextDueBasedOn: item?.SetNextDueBasedOnId || "2",
      odometerTriggerTimeBasedDueSoonThresholdIntervalValue: item?.OdometerTriggerTimeBasedDueSoonThresholdIntervalValue || "",
      odometerTriggerTimeBasedDueSoonThresholdIntervalTypeName: item?.OdometerTriggerTimeBasedDueSoonThresholdIntervalTypeName || "",
      //Do not use now
      // operationalHoursTriggerRequired: item?.OperationalHoursTriggerRequired,
      // operationalHoursTriggerRepeatIntervalHours: item?.OperationalHoursTriggerRepeatIntervalHours,
      // operationalHoursTriggerDueSoonThresholdIntervalHours: item?.OperationalHoursTriggerDueSoonThresholdIntervalHours

    }
  });

  const isTimeTriggerChecked = watch("timeTrigger");
  const isOdometerTriggerChecked = watch("odometerTrigger");
  const categoryChanged = watch("category");
  const isRecurringWatcher = watch("isRecurring");

  const odometerTriggerTimeBasedDueSoonThresholdIntervalTypeNameWatcher = watch("odometerTriggerTimeBasedDueSoonThresholdIntervalTypeName");
  const odometerTriggerTimeBasedDueSoonThresholdIntervalValueWatcher = watch("odometerTriggerTimeBasedDueSoonThresholdIntervalValue");

  //const NextDueBasedOn = watch("setNextDueBasedOn");


  useEffect(() => {
    if (item) {

      //activate this tab
      const thisIndex = reminderTypeTabList
        .findIndex((i) => i.ReminderTypeId === item.ReminderTypeId);
      setTabIndex(thisIndex + 2);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isTimeTriggerChecked) {
      setValue("timeTriggerDueSoonThresholdIntervalTypeName", "");
      setValue("timeTriggerDueSoonThresholdIntervalValue", "");
      setValue("timeTriggerRepeatIntervalTypeName", "");
      setValue("timeTriggerRepeatIntervalValue", "");

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTimeTriggerChecked]);

  useEffect(() => {
    if (!isOdometerTriggerChecked) {
      setValue("odometerTriggerRepeatIntervalKm", "");
      setValue("odometerTriggerDueSoonThresholdIntervalKm", "");
      setValue("odometerTriggerTimeBasedDueSoonThresholdIntervalValue", "");
      setValue("odometerTriggerTimeBasedDueSoonThresholdIntervalTypeName", "");

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOdometerTriggerChecked]);

  useEffect(() => {
    if (!isRecurringWatcher) {
      setValue("odometerTriggerRepeatIntervalKm", "");
      setValue("timeTriggerRepeatIntervalTypeName", "");
      setValue("timeTriggerRepeatIntervalValue", "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRecurringWatcher]);



  useEffect(() => {
    if (categoryChanged.toString() === "1") {
      setValue("setNextDueBasedOn", "1");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryChanged]);

  // useEffect(() => {
  //   setValue('setNextDueBasedOn', NextDueBasedOn);
  // }, [NextDueBasedOn]);

  useEffect(() => {
    getCategory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCategory = async () => {
    setSpinner(true);

    try {

      const resData = await RemindersApi.getCategoryList(1, 500);

      setCategory(resData.Data);

      const resSubData = await RemindersApi.getSubCategoryList(1, 500);

      setSubcategory(resSubData.Data);

      setValue("category", item?.CategoryId ?? "");
      setValue("subcategory", item?.SubCategoryId ?? "");

    } catch (err) {
      console.log('err', err);
    }

    setSpinner(false);
  };



  const resetForm = () => {
    reset();
    getCategory();
  };

  const onSubmit = handleSubmit(async (data) => {

    setSpinner(true);

    try {

      const reminderTypeDto: RemindersApi.IReminderTypeInputDto = {
        Name: data.typeName,
        Code: data.typeCode,
        Description: data.typeDesc,
        CategoryId: Number(data.category),
        SubCategoryId: Number(data.subcategory),
        IsRecurring: data.isRecurring,
        SetNextDueBasedOn: data.setNextDueBasedOn,
        TimeTriggerRequired: data.timeTrigger,
        TimeTriggerRepeatIntervalType: data.timeTriggerRepeatIntervalTypeName,
        TimeTriggerRepeatIntervalValue: (data.timeTrigger && data.isRecurring) ? Number(data.timeTriggerRepeatIntervalValue) : null,
        TimeTriggerDueSoonThresholdIntervalType: data.timeTriggerDueSoonThresholdIntervalTypeName,
        TimeTriggerDueSoonThresholdIntervalValue: data.timeTrigger ? Number(data.timeTriggerDueSoonThresholdIntervalValue) : null,
        OdometerTriggerRequired: data.odometerTrigger,
        OdometerTriggerRepeatIntervalKm: (data.odometerTrigger && data.isRecurring) ? Number(data.odometerTriggerRepeatIntervalKm) : null,
        OdometerTriggerDueSoonThresholdIntervalKm: data.odometerTrigger ? Number(data.odometerTriggerDueSoonThresholdIntervalKm) : null,
        OdometerTriggerTimeBasedDueSoonThresholdIntervalType: data.odometerTriggerTimeBasedDueSoonThresholdIntervalTypeName ?? null,
        OdometerTriggerTimeBasedDueSoonThresholdIntervalValue: data.odometerTriggerTimeBasedDueSoonThresholdIntervalValue ? Number(data.odometerTriggerTimeBasedDueSoonThresholdIntervalValue) : null,
        OperationalHoursTriggerRequired: false,
        OperationalHoursTriggerRepeatIntervalHours: null,
        OperationalHoursTriggerDueSoonThresholdIntervalHours: null,

      };


      //console.log("reminderTypeDto", reminderTypeDto);

      if (item) {
        //update
        await RemindersApi.updateReminderType(item.ReminderTypeId, reminderTypeDto);

        const filtered = reminderTypeTabList.filter((i) => {
          return i.ReminderTypeId !== item.ReminderTypeId;
        });

        setReminderTypeTabList(filtered);

      }
      else {
        //insert
        await RemindersApi.addReminderType(reminderTypeDto);
        resetForm();
      }

      showSuccess("success", "sucessfully saved", "", 3000, null);

      setTabIndex(0);
      setListRefresh(!listRefresh);
    }
    catch (err) {
      console.log("onSubmit.err", err);
    }

    setSpinner(false);

  });

  return (
    <>
      <form >
        <div className="row">
          <div className="col-lg-6  mt-3">
            <div className="tab-content" id="myTabContent">
              <div className="card">
                <div className="card-body">
                  <div className="row mt-3">
                    <div className="col-6 ">

                      <Button
                        type="button"
                        className="mb-3 ml-3"
                        style={{ fontWeight: "600" }}
                        variant="contained"
                        color="primary"
                        onClick={onSubmit}
                      >
                        Save
                      </Button>

                    </div>
                    <div className="col-6 text-right ">
                      {item &&
                        <Button
                          type="button"
                          className="mb-3 ml-3"
                          style={{ fontWeight: "600" }}
                          variant="contained"
                          color="default"
                          onClick={resetForm}
                        >
                          Reset
                        </Button>
                      }
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-6">
                      <div className="p-number">
                        <Controller
                          name="typeName"
                          rules={{ required: true }}
                          control={control}
                          render={({ field }) => <TextField
                            {...field}
                            style={{ width: "100%" }}
                            label=""
                            variant="outlined"
                            size="small"
                            error={errors.typeName ? true : false}
                            helperText={""}
                          />}
                        />
                      </div>
                      <span className="p-num-span mr-2">
                        Name
                      </span>
                      {errors.typeName && <p className="text-danger2">should not be blank</p>}
                    </div>
                    <div className="col-md-6">
                      <div className="p-number">

                        <Controller
                          name="typeCode"
                          //rules={{ required: true }}
                          control={control}
                          render={({ field }) => <TextField
                            {...field}
                            style={{ width: "100%" }}
                            label=""
                            variant="outlined"
                            size="small"
                            error={errors.typeCode ? true : false}
                            helperText={""}
                          />}
                        />
                      </div>
                      <span className="p-num-span mr-2">
                        Code
                      </span>
                      {errors.typeCode && <p className="text-danger2">should not be blank</p>}
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col">
                      <div className="p-number">
                        <Controller
                          name="typeDesc"
                          //rules={{ required: true }}
                          control={control}
                          render={({ field }) => <TextField
                            {...field}
                            style={{ width: "100%" }}
                            label=""
                            variant="outlined"
                            size="small"
                            error={errors.typeDesc ? true : false}
                            helperText={""}
                          />}
                        />
                      </div>
                      <span className="p-num-span mr-2">
                        Description
                      </span>
                      {errors.typeDesc && <p className="text-danger2">should not be blank</p>}
                    </div>
                  </div>

                  <div className="row mt-3">
                    <div className="col-md-6">
                      <div className="p-number">
                        <Controller
                          name="category"
                          rules={{ required: true }}
                          control={control}
                          defaultValue={""}
                          render={({ field }) => (
                            <FormControl
                              style={{ width: "100%" }}
                              variant="outlined"
                              size="small"
                            >
                              <Select  {...field}
                                inputProps={{ "aria-label": "Without label" }}

                              >

                                <MenuItem key={"00"} value=""></MenuItem>
                                {
                                  category && category?.map((category) =>
                                    <MenuItem key={category.Id} value={category.Id}>{category.Name}</MenuItem>
                                  )
                                }

                              </Select>
                            </FormControl>
                          )}
                        />
                      </div>
                      <span className="p-num-span mr-2">
                        Category
                      </span>
                      {errors.category && <p className="text-danger2">should not be blank</p>}
                    </div>
                    <div className="col-md-6">
                      <div className="p-number">

                        <Controller
                          name="subcategory"
                          rules={{ required: true }}
                          control={control}
                          render={({ field }) => (
                            <FormControl
                              style={{ width: "100%" }}
                              variant="outlined"
                              size="small"
                            >
                              <Select  {...field}
                                inputProps={{ "aria-label": "Without label" }}
                                defaultValue={""}
                              >
                                <MenuItem key={"00"} value=""></MenuItem>
                                {
                                  subcategory && subcategory?.map((subcategory) =>
                                    <MenuItem key={subcategory.Id} value={subcategory.Id}>{subcategory.Name}</MenuItem>
                                  )
                                }
                              </Select>
                            </FormControl>
                          )}
                        />
                      </div>
                      <span className="p-num-span mr-2">
                        Subcategory
                      </span>
                      {errors.subcategory && <p className="text-danger2">should not be blank</p>}
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6  mt-3">
            <div className="tab-content" id="myTabContent">
              <div className="card">
                <div className="card-body">
                  <div id="map" className="map-full" >
                    <div className="row mt-3">
                      <div className="col-sm-6">

                        <Controller
                          name="isRecurring"
                          control={control}
                          render={({ field }) => (
                            <FormControlLabel {...field} control={<Checkbox name="isRecurring" color="primary" checked={field.value} />} label="Recurring" />
                          )}
                        />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-6">
                        <div className="p-number">
                          <Controller

                            name="setNextDueBasedOn"
                            rules={{ required: isTimeTriggerChecked }}
                            control={control}
                            render={({ field }) => (
                              <FormControl
                                style={{ width: "100%" }}
                                variant="outlined"
                                size="small"
                              >
                                <Select  {...field}
                                  inputProps={{ "aria-label": "Without label" }}
                                  defaultValue={""}
                                  error={errors.setNextDueBasedOn ? true : false}
                                >
                                  <MenuItem value=""></MenuItem>
                                  <MenuItem value="1">Current Due Value</MenuItem>
                                  <MenuItem value="2">Value At Completion</MenuItem>
                                </Select>
                              </FormControl>
                            )}
                          />
                        </div>
                        <span className="p-num-span mr-2">
                          Set Next Due Based on
                        </span>
                        {(errors.setNextDueBasedOn)
                          && <p className="text-danger2">should not be blank</p>}
                      </div>

                    </div>


                    <div className="row mt-3">
                      <div className="col">

                        <Controller
                          name="timeTrigger"
                          control={control}
                          render={({ field }) => (
                            <FormControlLabel {...field}
                              control={<Checkbox name="timeTrigger" color="primary" checked={field.value} />} label="Time Trigger" />
                          )}
                        />
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-md-6">
                        <div className='row'>
                          <div className="col-6">
                            <div className="p-number">

                              <Controller
                                name="timeTriggerDueSoonThresholdIntervalValue"
                                rules={{ required: isTimeTriggerChecked, min: 1 }}
                                control={control}
                                render={({ field }) => <TextField
                                  type="number"
                                  {...field}
                                  style={{ width: "100%" }}
                                  label=""
                                  variant="outlined"
                                  size="small"
                                  error={errors.timeTriggerDueSoonThresholdIntervalValue ? true : false}
                                  helperText={""}
                                  disabled={!isTimeTriggerChecked}
                                />}
                              />
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="p-number">
                              <Controller
                                name="timeTriggerDueSoonThresholdIntervalTypeName"
                                rules={{ required: isTimeTriggerChecked }}
                                control={control}
                                render={({ field }) => (
                                  <FormControl
                                    style={{ width: "100%" }}
                                    variant="outlined"
                                    size="small"
                                  >
                                    <Select  {...field}
                                      inputProps={{ "aria-label": "Without label" }}
                                      defaultValue={""}
                                      disabled={!isTimeTriggerChecked}
                                      error={errors.timeTriggerDueSoonThresholdIntervalTypeName ? true : false}
                                      displayEmpty
                                    >
                                      <MenuItem key={"00"} value="">None</MenuItem>
                                      {
                                        timeIntervalType && timeIntervalType?.map((timeInterval) =>
                                          <MenuItem key={timeInterval.Name} value={timeInterval.Name}>{timeInterval.Name}</MenuItem>
                                        )
                                      }
                                    </Select>
                                  </FormControl>
                                )}
                              />


                            </div>
                          </div>
                        </div>
                        <span className="p-num-span mr-2">
                          Due Soon Threshold

                        </span>
                        {(errors.timeTriggerDueSoonThresholdIntervalValue || errors.timeTriggerDueSoonThresholdIntervalTypeName)
                          && <p className="text-danger2">should not be blank</p>}
                      </div>

                      <div className="col-md-6">
                        <div className='row'>
                          <div className="col-6">
                            <div className="p-number">

                              <Controller
                                name="timeTriggerRepeatIntervalValue"
                                rules={{ required: isTimeTriggerChecked && isRecurringWatcher, min: 1 }}
                                control={control}
                                render={({ field }) => <TextField
                                  type="number"
                                  {...field}
                                  style={{ width: "100%" }}
                                  label=""
                                  variant="outlined"
                                  size="small"
                                  error={errors.timeTriggerRepeatIntervalValue ? true : false}
                                  helperText={""}
                                  disabled={!isTimeTriggerChecked || !isRecurringWatcher}
                                />}
                              />
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="p-number">
                              <Controller
                                name="timeTriggerRepeatIntervalTypeName"
                                rules={{ required: isTimeTriggerChecked && isRecurringWatcher }}
                                control={control}
                                render={({ field }) => (
                                  <FormControl
                                    style={{ width: "100%" }}
                                    variant="outlined"
                                    size="small"
                                  >
                                    <Select  {...field}
                                      inputProps={{ "aria-label": "Without label" }}
                                      defaultValue={""}
                                      disabled={!isTimeTriggerChecked || !isRecurringWatcher}
                                      error={errors.timeTriggerRepeatIntervalTypeName ? true : false}
                                      displayEmpty
                                    >
                                      <MenuItem key={"00"} value="">None</MenuItem>
                                      {
                                        timeIntervalType && timeIntervalType?.map((timeInterval) =>
                                          <MenuItem key={timeInterval.Name} value={timeInterval.Name}>{timeInterval.Name}</MenuItem>
                                        )
                                      }
                                    </Select>
                                  </FormControl>
                                )}
                              />
                            </div>
                          </div>
                        </div>
                        <span className="p-num-span mr-2">
                          Repeat Interval
                        </span>
                        {(errors.timeTriggerRepeatIntervalValue || errors.timeTriggerRepeatIntervalTypeName)
                          && <p className="text-danger2">should not be blank</p>}
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col">

                        <Controller
                          name="odometerTrigger"
                          control={control}
                          render={({ field }) => (
                            <FormControlLabel {...field} control={<Checkbox name="odometerTrigger" color="primary" checked={field.value} />} label="Odometer Trigger" />
                          )}
                        />
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-md-6">
                        <div className='row'>
                          <div className="col">
                            <div className="p-number">

                              <Controller
                                name="odometerTriggerDueSoonThresholdIntervalKm"
                                rules={{ required: isOdometerTriggerChecked, min: 1 }}
                                control={control}
                                render={({ field }) => <TextField
                                  type="number"
                                  {...field}
                                  style={{ width: "100%" }}
                                  label=""
                                  variant="outlined"
                                  size="small"
                                  error={errors.odometerTriggerDueSoonThresholdIntervalKm ? true : false}
                                  helperText={""}
                                  disabled={!isOdometerTriggerChecked}
                                />}
                              />
                            </div>
                          </div>

                        </div>
                        <span className="p-num-span mr-2">
                          Due Soon Threshold (km)

                        </span>
                        {errors.odometerTriggerDueSoonThresholdIntervalKm && <p className="text-danger2">should not be blank</p>}
                      </div>

                      <div className="col-md-6">
                        <div className='row'>
                          <div className="col">
                            <div className="p-number">

                              <Controller
                                name="odometerTriggerRepeatIntervalKm"
                                rules={{ required: isOdometerTriggerChecked && isRecurringWatcher, min: 1 }}
                                control={control}
                                render={({ field }) => <TextField
                                  type="number"
                                  {...field}
                                  style={{ width: "100%" }}
                                  label=""
                                  variant="outlined"
                                  size="small"
                                  error={errors.odometerTriggerRepeatIntervalKm ? true : false}
                                  helperText={""}
                                  disabled={!isOdometerTriggerChecked || !isRecurringWatcher}
                                />}
                              />

                            </div>
                          </div>

                        </div>
                        <span className="p-num-span mr-2">
                          Repeat Interval (Km)
                        </span>
                        {errors.odometerTriggerRepeatIntervalKm && <p className="text-danger2">should not be blank</p>}
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-6">
                        <div className='row'>
                          <div className="col-6">
                            <div className="p-number">

                              <Controller
                                name="odometerTriggerTimeBasedDueSoonThresholdIntervalValue"
                                rules={{ required: odometerTriggerTimeBasedDueSoonThresholdIntervalTypeNameWatcher !== "", min: 1 }}
                                control={control}
                                render={({ field }) => <TextField
                                  type="number"
                                  {...field}
                                  style={{ width: "100%" }}
                                  label=""
                                  variant="outlined"
                                  size="small"
                                  error={errors.odometerTriggerTimeBasedDueSoonThresholdIntervalValue ? true : false}
                                  helperText={""}
                                  disabled={!isOdometerTriggerChecked}
                                />}
                              />
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="p-number">
                              <Controller
                                name="odometerTriggerTimeBasedDueSoonThresholdIntervalTypeName"
                                rules={{ required: odometerTriggerTimeBasedDueSoonThresholdIntervalValueWatcher !== "" }}
                                control={control}
                                render={({ field }) => (
                                  <FormControl
                                    style={{ width: "100%" }}
                                    variant="outlined"
                                    size="small"
                                  >
                                    <Select  {...field}
                                      inputProps={{ "aria-label": "Without label" }}
                                      defaultValue={""}
                                      disabled={!isOdometerTriggerChecked}
                                      error={errors.odometerTriggerTimeBasedDueSoonThresholdIntervalTypeName ? true : false}
                                      displayEmpty
                                    >
                                      <MenuItem key={"00"} value="">None</MenuItem>
                                      {
                                        timeIntervalType && timeIntervalType?.map((timeInterval) =>
                                          <MenuItem key={timeInterval.Name} value={timeInterval.Name}>{timeInterval.Name}</MenuItem>
                                        )
                                      }
                                    </Select>
                                  </FormControl>
                                )}
                              />
                            </div>
                          </div>
                        </div>
                        <span className="p-num-span mr-2">
                          Due Soon Threshold(Time)
                        </span>
                        <Tooltip title="Uses the average weekly distance travelled by the asset to estimate the date when Reminder would become due and uses that to generate a due soon notification " aria-label="Vehicles">
                          <span className="p-num-span mr-2 opt-l-number">
                            <InfoOutlinedIcon fontSize='small' /> Optional
                          </span>

                        </Tooltip>

                        {(errors.odometerTriggerTimeBasedDueSoonThresholdIntervalValue || errors.odometerTriggerTimeBasedDueSoonThresholdIntervalTypeName)
                          && <p className="text-danger2">should not be blank</p>}
                      </div>


                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form >
    </>
  );
};

export default ReminderTypeDetail;